module.exports = __webpack_public_path__ + "assets/img/role-9d15960e.png";